import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import useButtonLoader from "hooks/useButtonLoader";
import Logo from "assets/images/fullLogo.png";
import useCookie from "hooks/useCookie";
import { encryptData } from "config/config";
import { login } from "services/auth";
import { useAdminAuth } from "context/context";

const IPAccessLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [errors, setError] = useState({ email: "", password: "" });
  const { setCookie } = useCookie();
  const { setRoles } = useAdminAuth();
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Log In",
    "Please wait..."
  );
  //************Handel Login Form Validation********************** */
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!email) {
      formIsValid = false;
      errors["email"] = "Please enter Email Id";
    }
    if (!password) {
      formIsValid = false;
      errors["password"] = "Please enter Password";
    }
    setError(errors);
    return formIsValid;
  };

  //*************Handel User Login ************************/
  const userLogin = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      const res = await login({ email, password, type: "admin" });
      console.log("check");
      console.log(email);
      setSubmitLoading(false);

      if (res.code === 200) {
        setCookie(res.data.access_token);
        setRoles(res.data?.roleAccess || []);
        localStorage.setItem(
          process.env.REACT_APP_AUTH,
          encryptData(res.data?.roleAccess)
        );
        localStorage.setItem("roleid", res.data?.roleId);
        localStorage.setItem("mentorid", res.data?.userid);
        localStorage.setItem("mentorname", res.data?.name);
        if (res.data.roleName === "Affiliate Admin") {
          navigate("/center-management");
        } else if (res.data?.roleId != 26) {
          toast.error("Please log in using your IP access credentials only!")
        } else {
          toast.success("Login Successfully");
          navigate("/ip-access-management");
        }
        
      } else {
        toast.error(res.message);
      }
    }
  };

  //*********Password toggle hide show******** */
  const togglePassword = (e) => {
    e.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  // // checks user is logged in or not
  // React.useEffect(() => {
  //   if (cookies) {
  //     navigate("/dashboard");
  //   }
  // }, [navigate, cookies]);
  return (
    <React.Fragment>
      <title>Shubhra Viraj | Login</title>
      <div className="LoginArea login_section" style={{ backgroundColor: "#fef3e9" }}>
        <form method="POST">
          <div className="LoginBox">
            <figure>
              <img src={Logo} alt="logo" className=" my-2" loading="lazy" />
            </figure>

            <h5 className="m-0">IP Access Management</h5>

            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Email Id"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="Icon">
                <i className="fa fa-user"></i>
              </span>
              <span style={{ color: "red" }} className="error">
                {errors.email}
              </span>
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type={passwordType}
                placeholder="Enter Password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="passwordHideShow"
                onClick={(e) => {
                  togglePassword(e);
                }}
              >
                {passwordType === "password" ? (
                  <i className="fa fa-eye-slash"></i>
                ) : (
                  <i className="fa fa-eye"></i>
                )}
              </span>
              <span className="Icon">
                <i className="fa fa-unlock-alt"></i>
              </span>
              <span style={{ color: "red" }} className="error">
                {errors.password}
              </span>
            </div>
            <button onClick={userLogin} ref={submitButtonElement} style={{ boxShadow: "0px 23px 36px #f36c670d" }}>
              Log In <i className="fa fa-sign-in"></i>
            </button>
            <br></br>
            <Link to="/forgot-password" style={{ boxShadow: "0px 23px 36px #f36c670d" }}>Forgot Password</Link>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};
export default IPAccessLogin;
